module.exports = __webpack_public_path__ + "static/media/Monday_Step3_Image20.c627b1cf.jpg";